import { ExportProps } from '~types/exportProps';

import { formatDateString } from '~libs/dayjs';
import { formatCurrency } from '~libs/dataUtils';

import { selectLookupClients } from '~main/selectors/clients/clients';

const fields: ExportProps = {
  client_id: {
    type: 'multi-lookup',
    field: 'claim_item.client_id',
    caption: 'Client',
    placeholder: 'All',
    selectorOptions: selectLookupClients,
    columnDef: {
      id: 'client_id',
      accessorKey: 'full_name',
      header: 'Client',
    },
  },
  reference: {
    type: 'text-like',
    caption: 'Reference',
    checked: true,
    field: 'reconciliation.reference',
    placeholder: 'Filter...',
    columnDef: {
      id: 'reference',
      accessorKey: 'reference',
      header: 'Reference',
    },
  },
  service_name: {
    type: 'text-like',
    caption: 'SAH Service Type',
    checked: true,
    field: 'claim_item.sah_item.service.name',
    placeholder: 'Filter...',
    columnDef: {
      id: 'service_name',
      accessorKey: 'service_name',
      header: 'SAH Service Type',
    },
  },
  service_date: {
    type: 'date-range',
    field: 'claim_item.service_date',
    caption: 'Service Date',
    columnDef: {
      id: 'claim_item.service_date',
      accessorKey: 'service_date',
      header: 'Service Date',
      cell: (info) => formatDateString(info.getValue()),
    },
  },
  claimed: {
    type: 'text',
    field: 'claimed',
    caption: 'Claimed Amount',
    checked: true,
    columnDef: {
      id: 'claimed',
      accessorKey: 'claimed',
      header: 'Claimed Amount',
      cell: (info) => {
        const value = info.getValue();
        return value === null || value === undefined || value === '' ? '' : formatCurrency(value as string);
      },
    },
  },
  paid: {
    type: 'text',
    field: 'paid',
    caption: 'Paid Amount',
    checked: true,
    columnDef: {
      id: 'paid',
      accessorKey: 'paid',
      header: 'Paid Amount',
      cell: (info) => {
        const value = info.getValue();
        return value === null || value === undefined || value === '' ? '' : formatCurrency(value as string);
      },
    },
  },
  gov_contribution_amount: {
    type: 'text',
    field: 'gov_contribution_amount',
    caption: 'Government Contributions',
    checked: true,
    columnDef: {
      id: 'gov_contribution_amount',
      accessorKey: 'gov_contribution_amount',
      header: 'Government Contribution',
      cell: (info) => {
        const value = info.getValue();
        return value === null || value === undefined || value === '' ? '' : formatCurrency(value as string);
      },
    },
  },
  co_contribution_amount: {
    type: 'text',
    field: 'co_contribution_amount',
    caption: 'Client Contribution',
    checked: true,
    columnDef: {
      id: 'co_contribution_amount',
      accessorKey: 'co_contribution_amount',
      header: 'Client Contribution',
      cell: (info) => {
        const value = info.getValue();
        return value === null || value === undefined || value === '' ? '' : formatCurrency(value as string);
      },
    },
  },
};

export default fields;
